var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 442,
    height: 366,
    viewBox: "0 0 442 366",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.20703 94.1968V198.647H157.058L154.869 195.831L155.684 189.482L157.877 185.192L154.115 181.942L150.423 178.801L148.59 174.888L150.423 172.348L168.775 188.62L179.769 198.647H186.576V94.1968H3.20703Z",
    fill: "#F3F3F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M314.194 160.991V226.961C322.731 229.739 334.587 233.327 345.585 235.095C347.265 234.281 349.109 233.866 350.976 233.882C356.31 233.882 360.635 237.093 360.635 241.049C360.635 245.005 356.301 248.212 350.971 248.212C348.487 248.259 346.054 247.499 344.038 246.045C340.303 245.577 326.146 243.796 314.186 242.145V359.982H417.51V160.991H314.194Z",
    fill: "#F3F3F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M344.045 246.041C341.181 245.681 332.185 244.55 322.756 243.302V246.375H344.531C344.366 246.266 344.201 246.167 344.045 246.041Z",
    fill: "#DFDFDF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M323.164 229.756C330.149 231.828 338.066 233.886 345.585 235.095C347.264 234.281 349.109 233.866 350.975 233.882C356.31 233.882 360.634 237.093 360.634 241.049C360.634 243.164 359.399 245.066 357.432 246.375H408.955V229.756H323.164Z",
    fill: "#DFDFDF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M417.235 359.986H441.268V160.995H417.235V359.986Z",
    fill: "#DFDFDF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M322.752 190.197H408.955V173.579H322.752V190.197Z",
    fill: "#DFDFDF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M328.948 182.722C330.558 182.722 331.864 181.417 331.864 179.806C331.864 178.195 330.558 176.89 328.948 176.89C327.337 176.89 326.031 178.195 326.031 179.806C326.031 181.417 327.337 182.722 328.948 182.722Z",
    fill: "#F3F3F3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M379.189 179.806H334.312",
    stroke: "#F3F3F3",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M322.752 218.286H408.955V201.668H322.752V218.286Z",
    fill: "#DFDFDF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M328.948 210.811C330.558 210.811 331.864 209.505 331.864 207.895C331.864 206.284 330.558 204.979 328.948 204.979C327.337 204.979 326.031 206.284 326.031 207.895C326.031 209.505 327.337 210.811 328.948 210.811Z",
    fill: "#F3F3F3"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M379.189 207.895H334.312",
    stroke: "#F3F3F3",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M379.19 235.979H357.783",
    stroke: "#F3F3F3",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M322.752 274.463H408.955V257.845H322.752V274.463Z",
    fill: "#DFDFDF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M328.948 266.984C330.558 266.984 331.864 265.678 331.864 264.068C331.864 262.457 330.558 261.151 328.948 261.151C327.337 261.151 326.031 262.457 326.031 264.068C326.031 265.678 327.337 266.984 328.948 266.984Z",
    fill: "#F3F3F3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M379.189 264.068H334.312",
    stroke: "#F3F3F3",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M322.752 302.552H408.955V285.934H322.752V302.552Z",
    fill: "#DFDFDF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M328.948 295.073C330.558 295.073 331.864 293.767 331.864 292.156C331.864 290.546 330.558 289.24 328.948 289.24C327.337 289.24 326.031 290.546 326.031 292.156C326.031 293.767 327.337 295.073 328.948 295.073Z",
    fill: "#F3F3F3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M379.189 292.156H334.312",
    stroke: "#F3F3F3",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M435.714 185.535H422.783",
    stroke: "#F3F3F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M435.714 188.884H422.783",
    stroke: "#F3F3F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M435.714 208.306H422.783",
    stroke: "#F3F3F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M435.714 211.652H422.783",
    stroke: "#F3F3F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M435.714 235.979H422.783",
    stroke: "#F3F3F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M435.714 239.329H422.783",
    stroke: "#F3F3F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M435.714 262.755H422.783",
    stroke: "#F3F3F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M435.714 266.1H422.783",
    stroke: "#F3F3F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M109.698 109.394H26.26C20.6001 109.394 16.0117 113.982 16.0117 119.642V174.606C16.0117 180.266 20.6001 184.854 26.26 184.854H109.698C115.358 184.854 119.947 180.266 119.947 174.606V119.642C119.947 113.982 115.358 109.394 109.698 109.394Z",
    fill: "#D0D0D0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M269.096 223.07C276.029 228.556 292.106 238.128 296.656 239.376C301.401 240.676 337.705 245.248 344.045 246.041C346.061 247.495 348.494 248.255 350.978 248.208C356.313 248.208 360.642 245.001 360.642 241.045C360.642 237.088 356.308 233.877 350.983 233.877C349.116 233.862 347.272 234.277 345.592 235.091C327.856 232.235 307.892 224.656 303.216 223.391C299.693 219.261 292.652 213.476 288.076 209.823",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M168.129 201.967C180.375 220.258 196.569 240.568 201.712 240.568C203.914 240.568 210.08 235.485 215.02 230.692",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M206.137 211.812C204.373 213.957 202.215 216.756 201.47 218.082C198.675 215.651 151.866 172.613 150.77 172.613C150.277 172.62 149.804 172.811 149.444 173.148C149.084 173.486 148.863 173.945 148.824 174.437C148.824 180.122 152.954 180.421 158.098 185.842",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M230.347 185.747C219.488 180.27 202.813 203.561 203.16 207.509C203.389 210.109 210.193 215.972 216.749 219.387",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M272.503 225.588C275.077 248.554 273.149 271.686 270.336 273.948C263.251 279.676 217.266 274.381 214.714 271.252C212.244 268.219 210.415 184.339 242.447 178.562",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M251.135 179.091C255.035 180.426 258.293 183.277 261.036 187.194",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M257.289 191.133C258.02 189.597 259.182 188.307 260.634 187.42C271.468 180.872 288.706 204.874 288.368 208.883C288.03 212.891 272.135 224.569 265.483 223.274C264.123 223.009 262.017 220.076 260.153 215.959",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M158.102 185.842C156.41 187.354 155.305 189.414 154.983 191.659C154.66 193.905 155.14 196.193 156.338 198.119C157.536 200.046 159.376 201.488 161.533 202.192C163.69 202.896 166.026 202.816 168.129 201.967",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M185.359 1.771H54.5352V79.3333H185.359V1.771Z",
    fill: "#F3F3F3"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6188 0.908691H0.607422V78.471H46.6188V0.908691Z",
    fill: "#F3F3F3"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5117 68.0666C72.3164 63.4993 79.0677 55.7383 91.3484 53.0993C109.696 49.1516 115.004 27.7233 123.822 27.7233C134.89 27.7233 139.552 34.0673 144.12 34.0673C153.289 34.0673 162.922 25.5653 167.953 13.0073",
    stroke: "#B4ACF9",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8941 13.1807H7.39844V16.1533H39.8941V13.1807Z",
    fill: "#DEDEDE"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8941 23.1907H7.39844V26.1633H39.8941V23.1907Z",
    fill: "#DEDEDE"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8941 33.2007H7.39844V36.1734H39.8941V33.2007Z",
    fill: "#DEDEDE"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8199 43.2107H7.32422V46.1834H39.8199V43.2107Z",
    fill: "#DEDEDE"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8199 53.2207H7.32422V56.1934H39.8199V53.2207Z",
    fill: "#DEDEDE"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8199 63.2307H7.32422V66.2034H39.8199V63.2307Z",
    fill: "#DEDEDE"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5054 119.59H23.6348V122.563H67.5054V119.59Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5054 129.6H23.6348V132.573H67.5054V129.6Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5054 139.61H23.6348V142.583H67.5054V139.61Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4097 149.62H23.5391V152.593H67.4097V149.62Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4097 159.63H23.5391V162.603H67.4097V159.63Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4097 169.636H23.5391V172.608H67.4097V169.636Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M148.717 102.664H95.4905C89.8305 102.664 85.2422 107.252 85.2422 112.912V136.876C85.2422 142.536 89.8305 147.124 95.4905 147.124H148.717C154.377 147.124 158.965 142.536 158.965 136.876V112.912C158.965 107.252 154.377 102.664 148.717 102.664Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M120.328 110.832C121.697 110.832 122.807 109.723 122.807 108.354C122.807 106.985 121.697 105.875 120.328 105.875C118.959 105.875 117.85 106.985 117.85 108.354C117.85 109.723 118.959 110.832 120.328 110.832Z",
    fill: "#D0D0D0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M120.328 143.917C121.697 143.917 122.807 142.808 122.807 141.439C122.807 140.07 121.697 138.96 120.328 138.96C118.959 138.96 117.85 140.07 117.85 141.439C117.85 142.808 118.959 143.917 120.328 143.917Z",
    fill: "#D0D0D0"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M120.328 109.164V140.737",
    stroke: "#D0D0D0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M126.348 113.302V131.715",
    stroke: "#D0D0D0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M120.328 141.439L126.347 131.715",
    stroke: "#D0D0D0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M351.655 105.121C348.758 102.279 346.929 98.5254 346.478 94.4923C346.027 90.4593 346.981 86.3941 349.179 82.9827C351.378 79.5713 354.685 77.0225 358.544 75.7664C362.403 74.5104 366.577 74.6238 370.362 76.0877C372.783 72.3776 376.167 69.3953 380.153 67.46C384.138 65.5246 388.574 64.7089 392.987 65.1001C397.4 65.4914 401.624 67.0748 405.207 69.6811C408.789 72.2874 411.596 75.8185 413.327 79.8967C416.737 78.5175 420.493 78.2394 424.069 79.1013C427.646 79.9633 430.863 81.9221 433.27 84.7035C435.677 87.4849 437.155 90.9496 437.495 94.6124C437.835 98.2752 437.021 101.953 435.167 105.13L351.655 105.121Z",
    fill: "#B4ACF9"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M425.646 103.648V163.053",
    stroke: "#DFDFDF",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M311.551 136.568C314.645 142.526 321.543 144.719 326.887 144.719C339.791 144.719 344.718 132.287 344.718 128.083",
    stroke: "#DFDFDF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M310.736 73.7866C313.588 79.2076 315 84.9406 315 89.9499C315 101.815 313.02 109.948 311.534 117.064",
    stroke: "#DFDFDF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M245.609 65.9867C254.345 58.6937 264.165 53.2727 275.852 53.2727C285.454 53.2727 293.25 56.1327 299.282 60.4964",
    stroke: "#DFDFDF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M198.566 103.869C207.723 103.869 216.099 96.0688 225.056 86.5918",
    stroke: "#DFDFDF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M241.055 68.6431H228.15V81.5477H241.055V68.6431Z",
    fill: "#DFDFDF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M305.072 71.8324C308.203 71.8324 310.74 69.2947 310.74 66.1643C310.74 63.034 308.203 60.4963 305.072 60.4963C301.942 60.4963 299.404 63.034 299.404 66.1643C299.404 69.2947 301.942 71.8324 305.072 71.8324Z",
    fill: "#DFDFDF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M320.797 127.095L308.17 118.871L307.359 133.92L320.797 127.095Z",
    fill: "#DFDFDF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M251.135 166.65C251.135 166.65 250.793 181.99 250.828 184.161C250.828 185.483 246.135 186.228 242.451 185.929",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M242.519 174.827C241.967 174.92 241.407 174.961 240.847 174.948C233.866 174.827 228.341 166.858 228.51 157.147C228.532 153.365 229.522 149.652 231.387 146.361",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M252.487 154.673C253.123 154.691 253.746 154.859 254.306 155.162C254.865 155.465 255.346 155.896 255.709 156.418C256.073 156.941 256.308 157.542 256.397 158.172C256.486 158.803 256.425 159.445 256.221 160.048C256.016 160.65 255.673 161.197 255.219 161.643C254.765 162.089 254.212 162.422 253.606 162.616C253 162.81 252.356 162.858 251.728 162.758C251.099 162.658 250.502 162.412 249.986 162.039",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M257.5 156.9C259.667 155.318 259.996 144.355 254.58 140.793C249.302 137.326 234.672 136.672 227.652 127.815",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M230.971 140.022C229.394 138.921 224.471 132.438 223.635 130.67",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M226.266 142.665C224.533 140.88 223.289 137.768 222.734 135.649",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M238.409 156.351C238.933 156.262 239.274 155.701 239.172 155.097C239.07 154.493 238.562 154.075 238.038 154.164C237.515 154.252 237.173 154.814 237.275 155.418C237.377 156.022 237.885 156.44 238.409 156.351Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M234.065 153.988C234.065 155.188 233.415 158.49 232.133 161.411",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M236.652 166.247C237.143 166.124 237.595 165.881 237.967 165.538C238.339 165.196 238.62 164.767 238.784 164.288",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M214.727 271.252V365.333H268.356V274.975C257.146 278.953 217.101 274.16 214.727 271.252Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M296.656 239.376C301.401 240.676 337.706 245.248 344.046 246.041",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeo);
export default __webpack_public_path__ + "static/media/seo.1e41055106360dc781eaf7fc863d56d4.svg";
export { ForwardRef as ReactComponent };